import { hexToRgba } from '@/utils/colorUtils';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    color() {
      if (this.item.estimatedFixCost === 'Covered by Cynergy') {
        return { color: '#4D9FEB' };
      }
      if (this.item.impactScore >= 7) {
        return { color: '#DF399F' };
      }
      if (this.item.impactScore >= 4) {
        return { color: '#FFA600' };
      }
      return { color: '#00D0C4' };
    },
  },
  methods: {
    hexToRgba: (hex, alpha) => hexToRgba(hex, alpha),
  },
};
